import React, {Component} from 'react';
import {Col, Button, Card, CardBody, ButtonToolbar, Row} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Collapse from '../../../components/Collapse';
import DropZoneField from '../../../components/DropZoneField';
import EquipmentTable from './EquipmentTable'
import * as http from '../../../modules/http';
import LoadingProgress from "../../prize/components/AddStores";
import {eq_category_add} from "../../../redux/actions/EquipmentActions";
import * as environment from "../../../modules/environment";

const dor = `${process.env.PUBLIC_URL}/img/dor.png`;

class EquipmentList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false,
            newCategoryName: "",
            newCategoryId: 0,
            files: [[]],
            filesBase64: [[]],
            filesInfo: [{}]
        };
    }

    addItem = () => {
        this.setState({windowType: 1, newCategoryId: 0});
    };

    cancelAddItem = () => {
        this.setState({windowType: 0});
    };

    saveNewCategory = () => {

        let maxId = 0;
        let shouldDispatch = false;

        if(this.state.newCategoryId === 0) {
            for (var index in this.props.data){
                maxId = this.props.data[index].groupId;
            }

            maxId = maxId + 1;
            shouldDispatch = true;
        }
        else {
            maxId = this.state.newCategoryId;
        }

        const data = {
            id: maxId,
            name: this.state.newCategoryName,
            text: '',
            image: {
                name: (this.state.filesInfo[0] && this.state.filesInfo[0].name) ? this.state.filesInfo[0].name : "",
                size: (this.state.filesInfo[0] && this.state.filesInfo[0].size) ? this.state.filesInfo[0].size : "",
                data: (this.state.filesBase64[0] && this.state.filesBase64[0][0]) ? this.state.filesBase64[0][0] : ""
            }
        };

        http.postToServer(
            'equip/equip_cat_new',
            data,
            (response) => {
                //console.debug('postToServer');
                if(shouldDispatch) {
                    this.props.dispatch(eq_category_add(this.state.newCategoryName, data.id));
                }
                this.setState({windowType: 0, newCategoryId: data.id});

            },
            (response) => {
                console.warn('error storing', response);
            }
        );
    };

    selectDoc(files, index) {

        if (files.length === 0) {
            let tmp = this.state.files;
            tmp.splice(index, 1);

            let res = this.state.filesBase64;
            res.splice(index, 1);

            let info = this.state.filesInfo;
            info.splice(index, 1);
            this.setState({files: tmp, filesBase64: res, filesInfo: info});
        }
        else {
            // Saving name and size
            let tmpInfo = this.state.filesInfo;
            let fr = new FileReader();
            fr.onload = function () {
                let img = new Image();
                img.onload = function () {
                    tmpInfo[index] = {name: files[0].name, size: img.width + "x" + img.height};
                    tmpInfo.push({});
                };
                img.src = fr.result;
            };
            fr.readAsDataURL(files[0]);

            // Saving doc
            this.getFilesBase64Rec(files, [], 0,
                (result) => {
                    let tmp = this.state.files;
                    tmp[index] = files;
                    tmp.push([]);

                    let res = this.state.filesBase64;
                    res[index] = result;
                    res.push([]);
                    this.setState({files: tmp, filesBase64: res, filesInfo: tmpInfo});
                });
        }

    }

    getFilesBase64Rec(fileObjs, filesBase64, index, callback) {

        this.getBase64(fileObjs[index], (result) => {

            filesBase64.push(result);
            if (index < fileObjs.length - 1) {
                this.getFilesBase64Rec(fileObjs, filesBase64, index + 1, callback)
            }
            else {
                callback(filesBase64);
            }
        });
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.warn('Error: ', error);
        };
    }

    render() {

        let isloading = false; //this.props.storesDayManager === undefined;

        //console.log(this.props.data)

        return (
            <Row style={{flexDirection: "row-reverse"}}>
                {isloading && <Col md={4}>
                    <LoadingProgress/>
                </Col>}
                {!isloading && this.state.windowType === 0 && <Col md={12} lg={12}>
                    <Card>
                        <CardBody>
                            <div className="card__title">
                                <h5 className="bold-text">קטגוריות ראשיות</h5>
                                <h5 className="subhead">תלחץ על כפתור<span
                                    className="red-text"> פלוס </span> כדי להוספת קטגוריה חדשה </h5>
                                <Button color='primary' size='sm'
                                        style={{padding: "0px 15px", margin: "5px"}}
                                        onClick={() => this.addItem()}>
                                    <i className="fas fa-plus" > </i>
                                </Button>
                            </div>
                            {this.props.data.map((item,index) => {

                                let id = item.groupId === undefined ? this.state.newCategoryId : item.groupId;

                                let logoUrl = environment.getServerBasePath() + '/equip/equip_cat_download?equipCatID=' + id + '&hash=' + new Date().getTime();

                                return (<Collapse title={item.groupName} className="with-shadow">
                                    <Row>
                                        <Col md={2}>
                                            <Button color="primary" size='sm'
                                                    onClick={() => {this.setState({windowType: 1, newCategoryId: id, newCategoryName: item.groupName})}}>להחליף תמונה</Button>
                                        </Col>
                                        <Col md={10}>
                                            <img src={logoUrl} style={{maxWidth: '200px', objectFit: 'cover' }}/>
                                        </Col>
                                    </Row>
                                    <EquipmentTable groupId={id} groupName={item.groupName} data={item.data}/>
                                </Collapse>)

                            })}
                        </CardBody>
                    </Card>
                </Col>}

                {!isloading && this.state.windowType === 1 && <Col md={6} lg={6}>
                    <Card>
                        <CardBody style={{boxShadow: 'none'}}>
                            <div className='card__title'>
                                <h5 className='bold-text'>קטגוריה חדשה</h5>
                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>שם קטגוריה</label>
                                    <div className='form__form-group-field'>
                                        <input
                                            dir={"auto"}
                                            value={this.state.newCategoryName}
                                            onChange={(event) => this.setState({newCategoryName: event.target.value})}
                                        />
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>תמונה</label>
                                    <div className='form__form-group-field'>
                                        <DropZoneField customHeight
                                                       multi={false}
                                                       files={this.state.files[0]}
                                                       onChange={(files) => this.selectDoc(files, 0)}
                                        />
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <ButtonToolbar className="form__button-toolbar">
                                        <Button type="button" onClick={() => this.cancelAddItem()}>ביטול</Button>
                                        <Button color="primary" onClick={() => this.saveNewCategory()}>שמור</Button>
                                    </ButtonToolbar>
                                </div>

                            </form>
                        </CardBody>
                    </Card>
                </Col>}
            </Row>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        status: state.equipment.status,
        data: state.equipment.data.equip,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentList))